// GENERATED FILE - DO NOT EDIT.
// Source: docs/mixing-table.yaml. Regenerate with `npm run gen:colors`.

export const HUES = ["cyan","magenta","yellow","black","red","green","blue","orange","violet","teal","lime","azure","rose","mud"] as const;
export type Hue = (typeof HUES)[number];

export const CHROMATIC_HUES = ["cyan","magenta","yellow","red","green","blue","orange","violet","teal","lime","azure","rose"] as const;

export interface PaletteEntry {
  readonly name: string;
  readonly code: string;
  readonly hex: string;
  readonly family: 'chroma' | 'darkener' | 'mud';
  readonly unicode: string;
}

export const PALETTE: Readonly<Record<string, PaletteEntry>> = {
  cyan: { name: "CYAN", code: "CY", hex: "#13f3ff", family: "chroma", unicode: "▲" },
  magenta: { name: "MAGENTA", code: "MG", hex: "#f057e8", family: "chroma", unicode: "●" },
  yellow: { name: "YELLOW", code: "YE", hex: "#f8f919", family: "chroma", unicode: "■" },
  black: { name: "BLACK", code: "BK", hex: "#303030", family: "darkener", unicode: "▬" },
  red: { name: "RED", code: "RD", hex: "#e80709", family: "chroma", unicode: "✚" },
  green: { name: "GREEN", code: "GN", hex: "#11ef11", family: "chroma", unicode: "◆" },
  blue: { name: "BLUE", code: "BL", hex: "#0303ff", family: "chroma", unicode: "✖" },
  orange: { name: "ORANGE", code: "OR", hex: "#ff8a00", family: "chroma", unicode: "✚" },
  violet: { name: "VIOLET", code: "VI", hex: "#8a2be2", family: "chroma", unicode: "✖" },
  teal: { name: "TEAL", code: "TE", hex: "#12b39a", family: "chroma", unicode: "◆" },
  lime: { name: "LIME", code: "LI", hex: "#a6f01a", family: "chroma", unicode: "◆" },
  azure: { name: "AZURE", code: "AZ", hex: "#1a8cff", family: "chroma", unicode: "✖" },
  rose: { name: "ROSE", code: "RO", hex: "#ff4fa3", family: "chroma", unicode: "✚" },
  mud: { name: "MUD", code: "MU", hex: "#6b5a3a", family: "mud", unicode: "☠" },
};

/** Reference hexes for shaded hues (debug/DOM only; the renderer dithers). */
export const SHADE_HEX: Readonly<Record<string, string>> = {
  "cyan_shade": "#0a7a80",
  "magenta_shade": "#782c74",
  "yellow_shade": "#7c7d0d",
  "red_shade": "#740405",
  "green_shade": "#097809",
  "blue_shade": "#020280",
  "orange_shade": "#804500",
  "violet_shade": "#451671",
  "teal_shade": "#095a4d",
  "lime_shade": "#53780d",
  "azure_shade": "#0d4680",
  "rose_shade": "#802852"
};

/** Unordered distinct-hue pairs that do NOT mix to mud, per mode. */
export const MIX_TABLE: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  cmyk: {
    "cyan+magenta": "blue",
    "magenta+cyan": "blue",
    "cyan+yellow": "green",
    "yellow+cyan": "green",
    "magenta+yellow": "red",
    "yellow+magenta": "red",
    "blue+cyan": "azure",
    "cyan+blue": "azure",
    "blue+magenta": "violet",
    "magenta+blue": "violet",
    "green+cyan": "teal",
    "cyan+green": "teal",
    "green+yellow": "lime",
    "yellow+green": "lime",
    "red+yellow": "orange",
    "yellow+red": "orange",
    "red+magenta": "rose",
    "magenta+red": "rose",
  },
  rgb: {
    "red+green": "yellow",
    "green+red": "yellow",
    "green+blue": "cyan",
    "blue+green": "cyan",
    "red+blue": "magenta",
    "blue+red": "magenta",
    "yellow+red": "orange",
    "red+yellow": "orange",
    "yellow+green": "lime",
    "green+yellow": "lime",
    "cyan+green": "teal",
    "green+cyan": "teal",
    "cyan+blue": "azure",
    "blue+cyan": "azure",
    "magenta+red": "rose",
    "red+magenta": "rose",
    "magenta+blue": "violet",
    "blue+magenta": "violet",
  },
};

export const MODES = ["cmyk","rgb"] as const;
export type Mode = (typeof MODES)[number];
